module.exports = __webpack_public_path__ + "img/964-6bddf0.png";